// import React from 'react';

const progressDescription = ({ name, getDescription, fieldsValue }) => {
  if (!getDescription) return null;
  switch (name) {
    case 'test':
      return null;
    default:
      return getDescription(fieldsValue);
  }
};

export default progressDescription;
